module.exports = __webpack_public_path__ + "img/http-api.bea429db.svg";